import { z } from 'zod';

/**
 * Delivery-note asset ids as picked in the manual-run dialog. Options come from
 * the delivery-note fulltext search (or a pasted asset id) and are always asset
 * UUIDs. The dialog's form schema derives from this array schema, so form and
 * payload enforce the same contract.
 */
export const zodDeliveryNoteAssetIdsSchema = z.array(z.uuid());

export const zodRunContactPointPayloadSchema = z.object({
  assetIds: zodDeliveryNoteAssetIdsSchema.min(1),
});

export type RunContactPointPayload = z.infer<
  typeof zodRunContactPointPayloadSchema
>;
